var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.colors)?_c('div',[_c('v-btn',{style:(_vm.btnStyle),attrs:{"dense":"","depressed":""}},[_vm._v("Bouton")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }